import React, { useState, useEffect } from "react";
import { TriviaData } from "./triviaData";
import TriviaCard from "./triviaCard";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import "animate.css";
import Card from "./card";
import { useAuth } from "../../../context/AuthContext";

const Trivia = () => {
  const [answeredQuestions, setAnsweredQuestions] = useState([]);
  const [render, setRender] = useState(0);
  const { isAuthenticated, isLoading: authLoading, getUserId } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthenticated && !authLoading) {
      navigate("/");
    }
  }, [isAuthenticated, authLoading, navigate]);

  const handleRender = () => {
    setRender(render + 1);
  };

  useEffect(() => {
    const userId = getUserId();
    if (!userId) return;
    
    const apiUrl = process.env.REACT_APP_API_BASE_URL;
    axios
      .get(`${apiUrl}/questions/${userId}`)
      .then((response) => {
        setAnsweredQuestions(response.data);
      })
      .catch((error) => {
        console.error("Error al obtener las preguntas respondidas:", error);
      });
  }, [render, getUserId]);

  return (
    <section className="trivia">
      <div className="t-title">
        <img
          className="question-1 animate__animated animate__wobble"
          src="../../../images/trivia-i.png"
          alt=""
          width="50"
        />
        <h1 className="">¡Respondé las trivias y ganá figuritas!</h1>
        <img
          className="question-2 animate__animated animate__wobble"
          src="../../../images/trivia.png"
          alt=""
          width="55"
        />
      </div>
      <div className="trivia-container">
        {TriviaData.map((trivia) => {
          const isAnswered = answeredQuestions?.some(
            (item) => item.questionNumber === trivia.id
          );
          return isAnswered ? (
            <Card number={trivia.id} key={trivia.id} title={trivia.title} win={true} />
          ) : (
            <TriviaCard
              onClick={handleRender}
              key={trivia.id}
              title={trivia.title}
              number={trivia.id}
              data={trivia.data}
              length={answeredQuestions.length}
            />
          );
        })}
      </div>
      <div className="button-container" style={{marginBottom:"75px"}}>
        <Link className="button button-primary" to="/album">
          ¡Ir al Album!
        </Link>
      </div>
    </section>
  );
};

export default Trivia;
